var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogleIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8451 10.1845C17.8451 9.54631 17.7878 8.93267 17.6814 8.34358H9.20508V11.8249H14.0487C13.8401 12.9499 13.206 13.9031 12.2528 14.5413V16.7995H15.1614C16.8633 15.2327 17.8451 12.9254 17.8451 10.1845Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20484 18.98C11.6348 18.98 13.6721 18.1741 15.1612 16.7996L12.2526 14.5414C11.4467 15.0814 10.4157 15.4005 9.20484 15.4005C6.86075 15.4005 4.87665 13.8173 4.16893 11.69H1.16211V14.0218C2.64302 16.9632 5.68666 18.98 9.20484 18.98Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16917 11.6901C3.98917 11.1501 3.8869 10.5733 3.8869 9.98012C3.8869 9.38694 3.98917 8.81012 4.16917 8.27012V5.9383H1.16235C0.552805 7.1533 0.205078 8.52785 0.205078 9.98012C0.205078 11.4324 0.552805 12.8069 1.16235 14.0219L4.16917 11.6901Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20484 4.55954C10.5262 4.55954 11.7126 5.01363 12.6453 5.90545L15.2267 3.32408C13.668 1.87181 11.6307 0.979992 9.20484 0.979992C5.68666 0.979992 2.64302 2.99681 1.16211 5.93817L4.16893 8.26999C4.87665 6.14272 6.86075 4.55954 9.20484 4.55954Z",
    fill: "#EA4335"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-icon.91294691.svg";
export { ForwardRef as ReactComponent };